import { render, staticRenderFns } from "./DesiredStockOverview.vue?vue&type=template&id=9e945ff6&"
import script from "./DesiredStockOverview.vue?vue&type=script&lang=js&"
export * from "./DesiredStockOverview.vue?vue&type=script&lang=js&"
import style0 from "./DesiredStockOverview.vue?vue&type=style&index=0&id=9e945ff6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports